import script from "./NoSurvey.component.vue?vue&type=script&setup=true&lang=js"
export * from "./NoSurvey.component.vue?vue&type=script&setup=true&lang=js"

import "./NoSurvey.component.vue?vue&type=style&index=0&id=21bcef9c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bcef9c"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
